import React from 'react';
import { Badge } from '../Badge';
import type { Tone } from '../../types/domain';
const toneClass: Record<Tone, string> = {
  green: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  red: 'bg-red-50 text-red-700 border-red-200',
  orange: 'bg-amber-50 text-amber-700 border-amber-200',
  blue: 'bg-blue-50 text-blue-700 border-blue-200',
  gray: 'bg-slate-100 text-slate-600 border-slate-200'
};
const dotClass: Record<Tone, string> = {
  green: 'bg-emerald-600',
  red: 'bg-red-600',
  orange: 'bg-amber-500',
  blue: 'bg-blue-600',
  gray: 'bg-slate-400'
};
interface StatusBadgeProps {
  tone: Tone;
  children: React.ReactNode;
  className?: string;
}
export function StatusBadge({
  tone,
  children,
  className = ''
}: StatusBadgeProps) {
  return <Badge variant="outline" className={`gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ${toneClass[tone]} ${className}`} data-id="element-177" data-mp="2ygc67p2ccgop">
      <span className={`h-1.5 w-1.5 rounded-full ${dotClass[tone]}`} aria-hidden data-id="element-178" data-mp="3r019ru0onkhj" />
      {children}
    </Badge>;
}